export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const imgUrl = (u) =>
  u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
